import isEqual from 'lodash/isEqual';
import Omit from 'lodash/omit';
import concat from 'lodash/concat';
import toast from 'react-hot-toast';
import BrokenImage from '../assets/images/brokenimage.jpg';

export const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

export const getFileExtension = (filename) => {
  return filename.split('.').pop();
};

export const GetYearsOptions = () => {
  const curr_year = new Date().getFullYear();
  return Array.from(new Array(200), (v, i) => (
    <option key={curr_year - i} value={curr_year - i}>
      {curr_year - i}
    </option>
  ));
};

export const GetRattingsOptions = () => {
  return Array.from(new Array(5), (v, i) => (
    <option key={i + 1} value={i + 1}>
      {i + 1}
    </option>
  ));
};

export function numberWithCommas(number) {
  //return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  //return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  return number.toLocaleString('en-US', { maximumFractionDigits: 2 });
}
export function formatValueInCroresAndLakhs(value) {
  if (value >= 10000000) {
    const crore = value / 10000000;
    return crore + ' cr';
  } else if (value >= 100000) {
    const lakh = value / 100000;
    return lakh + ' lakh';
  } else if (value >= 1000) {
    const thousand = value / 1000;
    return thousand + 'k'; // Format to two decimal places
  } else {
    return value?.toString();
  }
}

export const getKeyValueData = (data) => {
  let options = [];
  if (data && data.length > 0) {
    data.map((el) => {
      options.push({
        _id: el.value,
        name: el.label || el.key,
        ...(el?.zone ? { zone: el?.zone } : {}),
      });
    });
  }
  return options;
};

/**
 * Converts an array of objects to label-value pairs.
 * @param {Array} data - The array of objects to be converted.
 * @returns {Array} An array of label-value pairs.
 */
export const getLabelValueData = (data) => {
  try {
    // Check if data is valid and not empty
    if (data && data.length) {
      return data.map((el) => ({
        value: el._id || el.id,
        label: el.name,
      }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const getLabelValueOptions = (data) => {
  try {
    if (data && data.length) {
      return data.map((el) => ({
        value: el.id || el._id || el.isoCode,
        label: el.name,
      }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const getLabelValueOptionsByName = (data) => {
  try {
    if (data && data.length) {
      return data.map((el) => ({
        value: el.name,
        label: el.name,
      }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

const currency_symbols = {
  INR: '₹',
};
export const getCurrencySymbol = (currency_code = 'INR') => {
  return currency_symbols[currency_code];
};

export const getGoogleRattingOptions = () => {
  let googleRattingOptions = [];
  for (let i = 3.5; i <= 5; i += 0.1) {
    let obj = {
      label: i.toFixed(1),
      value: i.toFixed(1),
    };
    googleRattingOptions.push(obj);
  }

  return googleRattingOptions;
};

export const getRoiOptions = () => {
  let options = [];
  for (let i = 0; i <= 42; i += 3) {
    const start = i;
    const end = i + 3;
    let obj = {
      label: `${start}-${end} Months`,
      value: `${start}-${end}`,
    };
    options.push(obj);
  }

  return options;
};

export function convertAmountToString(value) {
  if (value >= 10000000) {
    const crore = Math.floor((value / 10000000) * 100) / 100;
    return crore + ' cr';
  } else if (value >= 100000) {
    const lakh = Math.floor((value / 100000) * 100) / 100;

    return lakh + ' lakh';
  } else if (value >= 1000) {
    const thousand = Math.floor((value / 1000) * 100) / 100;
    return thousand + 'k';
  } else {
    return value?.toString();
  }
}

export const isObjectEmpty = (obj) => {
  if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj).length === 0;
  }
  return false;
};

export const isObjectEqual = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export function deepEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  }

  if (
    typeof obj1 !== 'object' ||
    typeof obj2 !== 'object' ||
    obj1 === null ||
    obj2 === null
  ) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export const isBothEqualObject = (obj1, obj2) => {
  let obj_one_copy = Omit(obj1, 'verificationinfo');
  let obj_two_copy = Omit(obj2, 'verificationinfo');
  return isEqual(obj_one_copy, obj_two_copy);
};

export const getValuesWithAllproperty = (data) => {
  return (
    data &&
    data.length &&
    data.map((el) => {
      return {
        ...el,
        value: el.id || el._id || el.isoCode,
        label: el.name,
      };
    })
  );
};

export const getFilteredZonesBasedData = (
  oldArray,
  newArray,
  zoneId,
  isZoneAdded,
  zones
) => {
  const clonedArray = newArray
    ?.filter((vl) => zoneId?.includes(vl?.zone_id))
    .map((z) => {
      const obj = {
        ...z,
        value: z?._id,
        label: z?.name,
      };
      if (isZoneAdded) {
        obj['zone'] = zones?.find((zo) => zo?._id === z?.zone_id);
      }
      return obj;
    });
  const uniqueValues = new Set();
  return concat(oldArray, clonedArray).filter((item) => {
    if (!uniqueValues.has(item.value)) {
      uniqueValues.add(item.value);
      return true;
    }
    return false;
  });
};

export const logo_treadmark_status = [
  'Government Processing',
  'Opposition and Responses',
  'Registration Certified',
];

export const getLogoTradmarkStatusOptions = () => {
  return logo_treadmark_status.map((el) => {
    return {
      label: el,
      value: el,
    };
  });
};

export const getDefaultIndiaCountry = (countries) => {
  let country = countries.find((el) => el.name === 'India');
  return [
    {
      label: country?.name,
      value: country?._id,
    },
  ];
};

export const getDefaultBussinessType = (bussinessTypes) => {
  let bussinessType = bussinessTypes.find((el) => el.name === 'Model');
  return {
    label: bussinessType?.name,
    value: bussinessType?._id,
  };
};

export function convertToLowerCaseWithUnderscore(arr) {
  if (!Array.isArray(arr)) {
    return [];
    //throw new Error('Input is not an array');
  }
  return arr.map((item) => {
    if (!item || typeof item !== 'object' || !item.name) {
      throw new Error('Invalid object in the array');
    }
    return item.name.toLowerCase().replace(/ /g, '_');
  });
}

export function convertUnderscoreToTitleCase(inputString) {
  if (typeof inputString !== 'string') {
    throw new Error('Input must be a string');
  }
  // Function logic remains the same
  return inputString
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// export const getErrorMessage = (error) => {
//   const errorMessage =
//     error?.data?.error?.additional_data?.message?.toString() ||
//     error?.data?.error?.err_message?.toString() ||
//     'Failed!';
//   toast.error(errorMessage);
//   return errorMessage;
// };

export const getErrorMessage = (error) => {
  let errorMessage = 'Failed!';

  if (
    error?.data?.error?.additional_data &&
    Object.keys(error.data.error.additional_data).length > 0
  ) {
    const additionalData = error.data.error.additional_data;
    const firstKey = Object.keys(additionalData)[0];
    const firstValue = additionalData[firstKey];
    errorMessage = firstValue.toString();
  } else if (error?.data?.error?.err_message) {
    errorMessage = error.data.error.err_message.toString();
  }
  toast.error(errorMessage);
  return errorMessage;
};

export const generateErrorMessage = (error) => {
  let errorMessage = 'Failed!';

  if (
    error?.data?.error?.additional_data &&
    Object.keys(error.data.error.additional_data).length > 0
  ) {
    const additionalData = error.data.error.additional_data;
    const firstKey = Object.keys(additionalData)[0];
    const firstValue = additionalData[firstKey];
    errorMessage = firstValue.toString();
  } else if (error?.data?.error?.err_message) {
    errorMessage = error.data.error.err_message.toString();
  }
  return errorMessage;
};

export function convertStringToNumbers(obj) {
  const newObj = {};
  for (const [key, value] of Object.entries(obj)) {
    // Check if the value is not empty
    if (value !== '' && value !== null && value !== undefined) {
      // Try to parse the value as a number
      const parsedValue = parseFloat(value);
      // Check if the parsed value is a valid number
      if (!isNaN(parsedValue)) {
        newObj[key] = parsedValue;
      } else {
        // If the value cannot be parsed as a number, keep it as it is
        newObj[key] = value;
      }
    } else {
      // If the value is empty, keep it as it is
      newObj[key] = value;
    }
  }
  return newObj;
}

export const getImageUrl = (path) => {
  return `${process.env.REACT_APP_IMAGE_HOST}/${path}`;
};

export const handleBrokenImageError = (e) => {
  e.target.src = BrokenImage;
};

export function getValueInLakhOrCrore(number, unit) {
  let multiplier = 1;

  // Determine the multiplier based on the unit
  if (unit.toLowerCase() === 'lakh') {
    multiplier = 100000;
  } else if (unit.toLowerCase() === 'crore') {
    multiplier = 10000000;
  } else {
    // If the unit is neither lakh nor crore, return null or handle the error accordingly
    return null;
  }

  // Calculate the value and return it
  return number * multiplier;
}

export function sortBussinessTypeData(data) {
  return [...data].sort((a, b) => {
    if (a.name === 'Model') return -1;
    if (b.name === 'Model') return 1;
    return 0;
  });
}
